//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/TaggedObjectCollection.js";
import "../Mechatronics/Mechatronics.PhysicsManager.js";
let d=[[],[[["name"],"FindObject",{R_:{folder:"Mechatronics.PMNavFolderObject"}},1,0],[["object"],"FindByObject",{R_:{folder:"Mechatronics.PMNavFolderObject"}},1,0],[["name"],"Create",{R_:{folder:"Mechatronics.PMNavFolderObject"}},1,0],[["name","groupType"],"CreateWithGroupType",{R_:{folder:"Mechatronics.PMNavFolderObject"}},2,0],[["folder","is_delete_member"],"Delete",{},2,0]],[]];
SPLM.Mechatronics.PMNavFolderObjectCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Mechatronics.PMNavFolderObjectCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Mechatronics.PMNavFolderObjectCollection.GroupType = Object.freeze({
    "BasicPhysics" : "BasicPhysics", "JointsAndConstraints" : "JointsAndConstraints", "Materials" : "Materials", "Couplers" : "Couplers", "SensorsAndActuators" : "SensorsAndActuators", "RuntimeBehaviors" : "RuntimeBehaviors", "Signals" : "Signals", "SignalConnection" : "SignalConnection", "FlexiblePhysics" : "FlexiblePhysics", "WebObjects" : "WebObjects", "DefaultCount" : "DefaultCount", "NonDefault" : "NonDefault"});

export default SPLM;